import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
  Button,
  useToast
} from '@chakra-ui/react';
import React from 'react';
import { AiFillBook } from 'react-icons/ai';
import { useMutation } from 'react-query';
import { api } from '../../../services/api';

export function EnviarListaParaFornecedor() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  const toast = useToast({
    position: 'top-right'
  });

  const { mutateAsync: enviarListaFornecedor, isLoading } = useMutation({
    mutationFn: async () => {
      const response = await api.get('/site/v2/pedido/envia-troca-compra');

      return response.data;
    },
    onSuccess: (data) => {
      console.log(data);
      toast({
        title: 'Enviado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true
      });

      onClose();
    },
    onError: (error) => {
      console.log(error);
      toast({
        title: 'Erro ao enviar',
        description: 'Tente novamente',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
    }
  });

  return (
    <>
      <Button
        colorScheme="blue"
        size="sm"
        mr="1rem"
        mb=".5rem"
        leftIcon={<AiFillBook />}
        maxW="fit-content"
        onClick={onOpen}>
        Enviar Lista para Fornecedor
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Enviar Lista para Fornecedor
            </AlertDialogHeader>

            <AlertDialogBody>
              Você tem certeza que deseja enviar a lista para o fornecedor?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button
                colorScheme="blue"
                loadingText="Enviando..."
                isLoading={isLoading}
                ml={3}
                onClick={() => enviarListaFornecedor()}>
                Enviar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
